module.exports = __webpack_public_path__ + "img/8trebol.a46a54d9.png";